import { ReactNode, TextareaHTMLAttributes } from "react";
import { Control } from "react-hook-form";
import { twMerge } from "tailwind-merge";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "@drpcrd/shared/ui";

type Props = {
  label?: ReactNode;
  description?: string;
  name: string;
  control: Control<any>;
  hideRequiredAsterisk?: boolean;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export const InputTextArea = ({
  control,
  name,
  label,
  description,
  maxLength,
  placeholder,
  required,
  hideRequiredAsterisk = false,
  onChange,
  ...rest
}: Props) => (
  <FormField
    control={control}
    name={name}
    render={({ field, fieldState: { error } }) => (
      <FormItem className="space-y-1.5">
        {(label || description) && (
          <div>
            {label && (
              <FormLabel className="flex w-full flex-row gap-1 font-sans text-sm font-semibold">
                <div>{label}</div>
                {required && !hideRequiredAsterisk && (
                  <div className="text-pink-500"> *</div>
                )}
              </FormLabel>
            )}

            {description && <FormDescription>{description}</FormDescription>}
          </div>
        )}

        <FormControl>
          <textarea
            {...field}
            onChange={(event) =>
              onChange ? onChange(event) : field.onChange(event)
            }
            placeholder={placeholder}
            rows={rest.rows}
            maxLength={maxLength}
            className={twMerge(
              "w-full rounded-lg border border-neutral-500 bg-white px-2 py-[10px] font-sans text-lg font-normal placeholder:text-neutral-900 focus-visible:outline-2 focus-visible:outline-black",
              error ? "border-pink-500 focus:border-pink-500" : "",
            )}
          />
        </FormControl>
        {error?.message && (
          <p className="font-normal text-pink-500">🚨 {error?.message}</p>
        )}
      </FormItem>
    )}
  />
);
